import { __assign } from "tslib";
import { breakpoints as bps } from '@metro-ui/tokens/js';
export var breakpoints = __assign({ xs: 0 }, bps);
/**
 * Creates a min-width based media query for the provided breakpoint.
 * @param {MediaQueryBreakpoint} breakpoint
 * @returns {string} media query `@media (min-width ...)`
 */
export function mq(breakpoint) {
    return "@media (min-width: ".concat(breakpoints[breakpoint], "px)");
}
//# sourceMappingURL=mediaQuery.js.map